module.exports = __webpack_public_path__ + "img/2.ce4e62f1.jpg";